























































import { Component, Vue } from 'vue-property-decorator';
import HelloWorld from '@/components/HelloWorld.vue'; // @ is an alias to /src
import PortalAcreditacion from '@/components/PortalAcreditacion.vue';
import PortalControlAcceso from '@/components/PortalControlAcceso.vue';
import PortalControlLaboral from '@/components/PortalControlLaboral.vue';

@Component({
  components: {
    PortalAcreditacion,
    PortalControlAcceso,
    PortalControlLaboral,
  },
})
export default class Home extends Vue {
  public acreditacion: string = '';
  public controlLaboral: string = '';
  public controlAcceso: string = '';

  constructor() {
    super();
    /*   Para deshabilitar una sección basta con comentar la linea de codigo mas abajo
    *
    *
    *
    * */
    this.acreditacion = 'http://caprmworkmate.com/acred/';
    this.controlAcceso = 'http://caprmworkmate.com/control_acceso/';
    this.controlLaboral = 'http://caprmworkmate.com/controllaboral/';
  }
}
